import type { DocumentTagsDropdownMenuItemFragment } from "../client/generated";
import { useState } from "react";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { Icon } from "@mdi/react";
import { mdiTagMultiple } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { useApolloClient } from "@apollo/client";
import { DocumentTagsDialogContent } from "./DocumentTagsDialogContent";
import { Dialog, DialogTrigger } from "@acdc2/ui/components/dialog";

type Props = {
  fragment: DocumentTagsDropdownMenuItemFragment;
};

export function DocumentTagsDropdownMenuItem({ fragment }: Props) {
  const { t } = useTranslation();
  const apolloClient = useApolloClient();
  const [isOpen, setIsOpen] = useState(false);

  const onOpenChange = (newOpen: boolean) => {
    setIsOpen(newOpen);
    if (!newOpen) {
      // Update possible tags for all other documents
      apolloClient.refetchQueries({ include: "active" });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <Icon path={mdiTagMultiple} size="1.25rem" />
          {t("DocumentTagsDropdownMenuItem.label")}
        </DropdownMenuItem>
      </DialogTrigger>
      <DocumentTagsDialogContent fragment={fragment} isOpen={isOpen} />
    </Dialog>
  );
}
